import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ButtonProps, IconButton } from "@mui/material";
import {
  gridFilteredDescendantCountLookupSelector,
  GridRowId,
  useGridApiContext,
  useGridSelector,
} from "@mui/x-data-grid-pro";
import { useEffect, useState } from "react";

interface ExpandGroupProps {
  id: GridRowId;
  field: string;
  rowNode: any;
  row: any;
  closedNestedRows?: boolean;
  handleExpandedRows?: (isOpen: boolean, id: string) => void;
}

const ExpandGroup = ({
  id,
  field,
  rowNode,
  row,
  closedNestedRows,
  handleExpandedRows,
}: ExpandGroupProps) => {
  const apiRef = useGridApiContext();
  const [isActive, setIsActive] = useState(false);
  const filteredDescendantCountLookup = useGridSelector(
    apiRef,
    gridFilteredDescendantCountLookupSelector
  );
  const filteredDescendantCount =
    filteredDescendantCountLookup[rowNode.id] ?? 0;

  useEffect(() => {
    if (closedNestedRows && isActive) {
      setIsActive(false);
    }
  }, [closedNestedRows]);

  const handleClick: ButtonProps["onClick"] = (event) => {
    if (rowNode.type !== "group") {
      return;
    }

    if (handleExpandedRows) {
      handleExpandedRows(!isActive, id as string);
    }
    setIsActive(!isActive);

    apiRef.current.setRowChildrenExpansion(id, !rowNode.childrenExpanded);
    apiRef.current.setCellFocus(id, field);
    event.stopPropagation();
  };

  // @ts-ignore
  return filteredDescendantCount > 0 ? (
    <>
      <IconButton
        data-testid={`expand-more-${row.invoiceNumber || row.lineNumber}`}
        onClick={handleClick}
      >
        {isActive ? (
          <KeyboardArrowDownIcon sx={{ width: "24px", height: "24px" }} />
        ) : (
          <KeyboardArrowRightIcon sx={{ width: "24px", height: "24px" }} />
        )}
      </IconButton>
    </>
  ) : (
    <>
      <IconButton disabled />
    </>
  );
};

export default ExpandGroup;
